export const options = {
    table: {
        number: {
            readonly: true,
            now: false,
            autocomplete: true
        },
        datetime: {
            readonly: true,
            now: true,
            autocomplete: true
        },
        image: {
            readonly: true,
            now: false,
            autocomplete: false
        },
        url: {
            readonly: true,
            now: false,
            autocomplete: true
        },
        phone: {
            readonly: true,
            now: false,
            autocomplete: true
        },
        linkedfield: {
            readonly: true,
            now: false,
            autocomplete: true
        },
        check: {
            readonly: true,
            now: false,
            autocomplete: true
        },
        lookup: {
            readonly: false,
            now: false,
            autocomplete: false
        },
        textarea: {
            readonly: true,
            now: false,
            autocomplete: true
        },
        text: {
            readonly: true,
            now: false,
            autocomplete: true
        },
        email: {
            readonly: true,
            now: false,
            autocomplete: true
        },
        formula: {
            readonly: false,
            now: false,
            autocomplete: false
        }
    },
    form: {
        create: {
            number: {
                readonly: false,
                now: false,
                autocomplete: true,
                optional: true,
                recipient: false,
                mandatory: false
            },
            datetime: {
                readonly: false,
                now: true,
                autocomplete: true,
                optional: true,
                recipient: false,
                mandatory: false
            },
            image: {
                readonly: false,
                now: false,
                autocomplete: false,
                optional: true,
                recipient: false,
                mandatory: false
            },
            url: {
                readonly: false,
                now: false,
                autocomplete: true,
                optional: true,
                recipient: false,
                mandatory: false
            },
            phone: {
                readonly: false,
                now: false,
                autocomplete: true,
                optional: true,
                recipient: false,
                mandatory: false
            },
            linkedfield: {
                readonly: false,
                now: false,
                autocomplete: true,
                optional: true,
                recipient: true,
                mandatory: false
            },
            check: {
                readonly: false,
                now: false,
                autocomplete: true,
                optional: false,
                recipient: false,
                mandatory: true
            },
            textarea: {
                readonly: false,
                now: false,
                autocomplete: true,
                optional: true,
                recipient: false,
                mandatory: false
            },
            text: {
                readonly: false,
                now: false,
                autocomplete: true,
                optional: true,
                recipient: false,
                mandatory: false
            },
            email: {
                readonly: false,
                now: false,
                autocomplete: true,
                optional: true,
                recipient: false,
                mandatory: false
            }
        },
        update: {
            number: {
                readonly: true,
                now: false,
                autocomplete: true,
                optional: true,
                recipient: false,
                mandatory: false
            },
            datetime: {
                readonly: true,
                now: true,
                autocomplete: true,
                optional: true,
                recipient: false,
                mandatory: false
            },
            image: {
                readonly: true,
                now: false,
                autocomplete: false,
                optional: true,
                recipient: false,
                mandatory: false
            },
            url: {
                readonly: true,
                now: false,
                autocomplete: true,
                optional: true,
                recipient: false,
                mandatory: false
            },
            phone: {
                readonly: true,
                now: false,
                autocomplete: true,
                optional: true,
                recipient: false,
                mandatory: false
            },
            linkedfield: {
                readonly: true,
                now: false,
                autocomplete: true,
                optional: true,
                recipient: false,
                mandatory: false
            },
            check: {
                readonly: true,
                now: false,
                autocomplete: true,
                optional: true,
                recipient: false,
                mandatory: false
            },
            textarea: {
                readonly: true,
                now: false,
                autocomplete: true,
                optional: true,
                recipient: false,
                mandatory: false
            },
            text: {
                readonly: true,
                now: false,
                autocomplete: true,
                optional: true,
                recipient: false,
                mandatory: false
            },
            email: {
                readonly: true,
                now: false,
                autocomplete: true,
                optional: true,
                recipient: false,
                mandatory: false
            }
        }
    }
}
